var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeftRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.62598 7.50002L10.7197 4.40627L9.83598 3.52252L5.85848 7.50002L9.83598 11.4775L10.7197 10.5938L7.62598 7.50002Z",
    fill: "#AC002D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftRed);
export default __webpack_public_path__ + "static/media/arrow_left_red.bf4ffbb137e41b86b72c478c897ee978.svg";
export { ForwardRef as ReactComponent };